import { render } from "./PolitiqueConfidentialitePage.vue?vue&type=template&id=44981636&scoped=true"
import script from "./PolitiqueConfidentialitePage.vue?vue&type=script&lang=js"
export * from "./PolitiqueConfidentialitePage.vue?vue&type=script&lang=js"

import "./PolitiqueConfidentialitePage.vue?vue&type=style&index=0&id=44981636&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44981636"]])

export default __exports__